module.exports = __webpack_public_path__ + "static/media/instluminarias.a222ee0b.jpg";